import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from 'axios';

export default {
  name: "leaveList",
  components: {
    MainLayout,
    Select2Multiple,
    flatPickr,
    Loading,
    AdvancedLaravelVuePaginate,
  },

  data() {
    return {
      isFilterOpen: false,
      CONFIG,
      periodOptions: [
        { id: '0', text: 'Morning' },
        { id: '1', text: 'Evening' },
        { id: '2', text: 'Full' },
      ],
      leaveData: {},
      searchData: {
        teacher_name: null,
        period: null,
        from_date: null,
        to_date: null,
        request_date: null,
        status: null
      },
      lastSearchParams: {},
      isLoading: false,
      search_status: false,
      noDataMsg: CONFIG.NO_DATA_FOUND,
    };
  },

  methods: {
    reset() {
      this.searchData.teacher_name = null;
      this.searchData.period = null;
      this.searchData.from_date = null;
      this.searchData.to_date = null;
      this.searchData.request_date = null;
      this.searchData.status = null;
      this.isLoading = true;
      this.getLeave();
    },

    getLeave(page = 1) {
      this.isLoading = true;
      this.search_status = false;

      const params = {
        campus_id: this.$store.state.user.campus_id,
      };
      axios.get('teacher/leave/list?page=' + page, { params })
        .then(res => {
          this.leaveData = res.data;
          this.lastSearchParams = params;
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Teacher Leave List API Error", error);
        });
    },

    searchLeave(page = 1) {
      this.isLoading = true;
      this.search_status = true;

      const params = {
        teacher_name: this.searchData.teacher_name,
        period: this.searchData.period,
        from_date: this.searchData.from_date,
        to_date: this.searchData.to_date,
        request_date: this.searchData.request_date,
        status: this.searchData.status,
        campus_id: this.$store.state.user.campus_id,
      };
      axios.get("teacher/leave/search?page=" + page, { params })
        .then(response => {
          this.leaveData = response.data;
          this.lastSearchParams = params;
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Teacher Leave Search API Error", error);
        });
    },

    confirmDelete(leaveId) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.delete(leaveId);
      }
    },

    delete(leaveId) {
      this.isLoading = true;

      axios.delete("teacher/leave/delete/" + leaveId)
        .then(res => {
          if (res.data.success == true) {
            this.$notification.success("Leave Deleted Successfully.", {
              timer: 3,
              position: "bottomCenter"
            });
          } else {
            this.$notification.error(res.data.error, {
              timer: 3,
              position: "bottomCenter"
            });
          }

          this.search_status ? this.searchLeave() : this.getLeave();
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        })
    },

    showCreate() {
      this.$router.push({
        name: "teacherLeaveCreate",
      });
    },

    showEdit(leaveId) {
      this.$router.push({
        name: "teacherLeaveEdit",
        params: {
          id: leaveId
        }
      });
    },

    showDetail(leaveId) {
      this.$router.push({
        name: "teacherLeaveDetail",
        params: {
          id: leaveId
        }
      });
    },

    handlePaginate(page) {
      if (this.search_status) {
        this.searchLeave(page);
      } else {
        this.getLeave(page);
      }
    },

    excelDownload() {
      this.isLoading = true;
      axios.get('teacher/leave/excelDownload', {
        params: this.lastSearchParams,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          fileLink.setAttribute('download', `teacher_leave_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.isLoading = true;
    this.getLeave();
  },
};
